import React, { Component } from 'react'
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import { Loader } from "react-overlay-loader";
import ReactTable from "react-table"
import 'react-table/react-table.css'

const COLUMN_WITH_INT_VALUE = ['nett', 'pph', 'gross'];

class AssignmentReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lovBranch: [],
      choosenOrg: '',
      lovPrograms: [],
      dataTable: [],
      loading: false,
      selectedPrograms: [],
      errorMessage: [],
      user: JSON.parse(window.localStorage.getItem('is_user')),
    }
  }

  componentDidMount = async () => {
    this.getProgramList();

    this.dataBranch();
    
    /*if (this.state.user.role_name !== 'CHD-HO') {
      this.dataBranch();
    }*/
  }

  dataBranch = () => {
    let { user } = this.state
    let url = '/api/traces_chd/v1/report/branch-list'
    request.getCHD(url, {
      success: function(response) {
        let { data } = response.data
        
        data.push({
          org_id: user.org_id,
          org_initial: user.org_initial,
          org_name: user.org_name
        })
        
        this.setState({ lovBranch: response.data.data || [], choosenOrg: user.origin === 'HO' ? 'ALL' : user.org_id })
      }.bind(this),
      error: function(e) {
        console.log(e)
      }.bind(this)
    })
  }

  handleChangeBranch = (e) => {
    let value = e.currentTarget.value
    this.setState({ choosenOrg: value })
  }

  renderBranch = () => {
    return (
      <div className="col-md-4">
        <div style={{marginTop: 10, marginBottom: 5}}><strong>Branch</strong></div>
        <select 
          className="form-control form-control-sm" 
          value={this.state.choosenOrg} 
          onChange={this.handleChangeBranch.bind(this)}
        >
          <option value="">- Select Branch -</option>
          <option value={'ALL'}>ALL</option>
          {
            this.state.lovBranch.map((item, index) => (
              <option value={item.org_name}>{item.org_name}</option>
            ))
          }
        </select>
      </div>
    )
  }

  getProgramList = () => {
    let url = '/api/traces_chd/v1/report/program-list'
    request.getCHD(url, {
      success: function(response) {
        let { data } = response.data
        this.setState({
            lovPrograms: data || []
        })
      }.bind(this),
      error: function(e) {
        console.log(e)
      }.bind(this)
    })
  }

  handleMultiSelect = (e) => {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ 
        selectedPrograms: value 
    });
  }
  
  renderProgram = () => {
    return (
        <div className="col-md-8">
            <div style={{marginBottom: 5}}><strong>Program List</strong></div>
            <div>
                <select 
                    className="form-control multiselect-height" 
                    name="program_name" multiple={true} 
                    onChange={this.handleMultiSelect.bind(this)} 
                    value={this.state.selectedPrograms} 
                    style={{"max-height": "120px", "overflow-y": "auto" }}>
                    {
                    this.state.lovPrograms.map((item, index) => (
                        <option key={index} value={item.program_id}>{item.lov_description}</option>
                    ))
                    }
                </select>
            </div>
            <small>(*) press ctrl + click to multiple select</small>
        </div>
    )
  };

  renderFilter = () => {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="card-body pt-1">
              {this.renderProgram()}
              {this.renderBranch()}
              <div className="row mt-4">
                <div className="col-md-3">
                  <button type="button" className="btn btn-primary btn-block" onClick={ this.handleSearch.bind(this) }><i className="fa fa-search" /> Search</button>
                </div>
                <div className="col-md-3">
                  <button type="button" className="btn btn-success btn-block" onClick={ this.handleExport.bind(this) }><i className="fa fa-file-excel" /> Export To Excel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  checkFilterValid = () => {
    let errorList = []

    if(this.state.selectedPrograms.length == 0) {
      errorList.push("Please select program")
    }

    this.setState({
      errorMessage: errorList
    });

    return (errorList.length > 0) ? false : true
    
  }

  handleSearch = () => {
    if(!this.checkFilterValid()) return;

    let { choosenOrg } = this.state
    
    let url = '/api/traces_chd/v1/report/assignment'
    let param = {
      branch: choosenOrg ? choosenOrg : 'ALL',
      selectedPrograms: this.state.selectedPrograms,
      export: false,
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        this.setState({ loading: false, dataTable: response.data.data || [] })
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: 'Ref Number',
          accessor: 'ref_number',
          filterable: true
        },
        {
          Header: 'Program Description',
          accessor: 'description',
          filterable: true
        },
        {
          Header: 'SKP Number',
          accessor: 'skp_number',
          filterable: true
        },
        {
          Header: 'Branch Code',
          accessor: 'branch_code',
          filterable: true
        },
        {
          Header: 'Customer Id',
          accessor: 'customer_id',
          filterable: true
        },
        {
          Header: 'Customer Name',
          accessor: 'customer_name',
          filterable: true
        },
        {
          Header: 'Package',
          accessor: 'package',
          filterable: true
        },
        {
          Header: 'Assign Date',
          accessor: 'assign_date',
          filterable: true
        },
        {
          Header: 'Claim Number',
          accessor: 'claim_number',
          filterable: true
        },
        {
          Header: 'Claim Status',
          accessor: 'claim_status',
          filterable: true
        },
        {
          Header: 'Claim Date',
          accessor: 'claim_date',
          filterable: true
        },
        {
          Header: 'Invoice Number',
          accessor: 'invoice_number',
          filterable: true
        },
        {
          Header: 'Invoice Transfer Date',
          accessor: 'invoice_transfer_date',
          filterable: true
        },
        {
          Header: 'Nett',
          accessor: 'nett',
          filterable: true
        },
        {
          Header: 'PPH',
          accessor: 'pph',
          filterable: true
        },
        {
          Header: 'Gross',
          accessor: 'gross',
          filterable: true
        },
        {
          Header: 'Status Kwitansi',
          accessor: 'status_kwitansi',
          filterable: true
        },
        {
          Header: 'Scan Kwitansi By',
          accessor: 'scan_kwitansi_by',
          filterable: true
        },
        {
          Header: 'Scan Kwitansi Date',
          accessor: 'scan_kwitansi_date',
          filterable: true
        },
        {
          Header: 'Period',
          accessor: 'period',
          filterable: true
        },
        {
          Header: 'Reject Reason',
          accessor: 'reject_reason',
          filterable: true
        },
        {
          Header: 'Rejected By',
          accessor: 'rejected_by',
          filterable: true
        }
      ],
      rows: this.state.dataTable
    }
    return (
        <ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
            defaultFilterMethod={((filter, row, column) => {
                let columnes = row[filter.id];

                if(columnes && COLUMN_WITH_INT_VALUE.includes(column.id)) {
                    columnes = columnes.toString();
                }
                return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
            })}
        />
    )
  }

  handleExport = () => {
    if(!this.checkFilterValid()) return;

    let { choosenOrg } = this.state
    
    let url = '/api/traces_chd/v1/report/assignment'
    let param = {
      branch: choosenOrg ? choosenOrg : 'ALL',
      selectedPrograms: this.state.selectedPrograms,
      export: true,
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let data = response.data.data
        this.setState({ loading: false, dataTable: data.data || [] })
        if (data.fullpath) {
          window.open(data.fullpath, '_blank')
          return false
        }
      }.bind(this),
      error: function(e) {
        let ErrorMessage = []
        
        if(e.response.data && e.response.data.message) ErrorMessage.push(e.response.data.message);
        else ErrorMessage.push('Failed to download, please try again');
        
        this.setState({ 
          loading: false,
          errorMessage: ErrorMessage
        })
      }.bind(this)
    })
  }

  showAlertComponent = () => {
    if (this.state.errorMessage.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.errorMessage.map((item, index) => {
              return <li key={index}><i className="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-header">Report Assignment</div>
                    <div className="card-body">
                      { this.showAlertComponent() }
                      { this.renderFilter() }
                      { this.renderTable() }
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
          <Loader fullPage loading={this.state.loading} />
      </div>
    )
  }
}

export default AssignmentReport